module.exports = __webpack_public_path__ + "img/sllr_TC.3324bddf.jpg";